import api from './api';

const adminLeaveTypesService = {
  // Get all leave types with pagination and filtering
  async getLeaveTypes(params = {}) {
    try {
      const response = await api.get('/admin/leave-types', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to get leave types:', error);
      throw error;
    }
  },

  // Get leave type by ID
  async getLeaveType(id) {
    try {
      const response = await api.get(`/admin/leave-types/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to get leave type:', error);
      throw error;
    }
  },

  // Create new leave type
  async createLeaveType(leaveTypeData) {
    try {
      const response = await api.post('/admin/leave-types', leaveTypeData);
      return response.data;
    } catch (error) {
      console.error('Failed to create leave type:', error);
      throw error;
    }
  },

  // Update leave type
  async updateLeaveType(id, leaveTypeData) {
    try {
      const response = await api.put(`/admin/leave-types/${id}`, leaveTypeData);
      return response.data;
    } catch (error) {
      console.error('Failed to update leave type:', error);
      throw error;
    }
  },

  // Delete leave type
  async deleteLeaveType(id) {
    try {
      const response = await api.delete(`/admin/leave-types/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete leave type:', error);
      throw error;
    }
  }
};

export default adminLeaveTypesService;